module.exports = __webpack_public_path__ + "assets/images/cosmote_7.c1e6d1f869cf2c13bb630e7e8ffbb2a0.png";